import { Asset, Attribute, Facility, GeoLocation } from '../../hickory-api';


export interface FacilityCompat extends Facility {
  typeAttr?: Attribute;
  brandAttr?: Attribute;
  brandGroupsAttr?: Attribute;
  areaAttr?: Attribute;
  subAreaAttr?: Attribute;
  attributes?: Array<Attribute>;
  source?: any;
}

export class FacilityHelper {
  static getAddressParts(facility: Facility): string[] {
    const parts: string[] = [];
    if (facility?.address1) {
      parts.push(facility.address1);
    }
    if (facility?.address2) {
      parts.push(facility.address2);
    }
    let address3 = '';
    address3 = facility?.city ? facility?.city + ', ' : '';
    address3 += facility?.state ? facility?.state + ' ' : '';
    address3 += facility?.postalCode ? facility?.postalCode + ' ' : '';
    address3 += facility?.country ? facility?.country : '';
    if (address3) {
      parts.push(address3);
    }

    return parts;
  }

  static parseGeoLocation(str: string): GeoLocation {
    if (!str) return null;
    let parts = str.split(';');
    if (parts?.length !== 2) parts = str.split(',');
    if (parts?.length !== 2) return null;
    const lat = parseFloat(parts[0]);
    const lng = parseFloat(parts[1]);
    if (isNaN(lat) || isNaN(lng)) return null;
    return { latitude: lat, longitude: lng };
  }

  static getMapsAddressQuery(facility: Facility): string {
    if (!facility) return null;
    let query = 'https://maps.google.com/maps?q='
      + (facility?.address1 || '') + ' '
      + (facility?.address2 || '') + ' '
      + (facility?.city || '') + ' '
      + (facility?.state || '') + ' '
      + (facility?.postalCode || '') + ' '
      + (facility?.country || '');

    if (facility?.location?.latitude && facility?.location?.longitude) {
      query += '&z=16&ll=' + facility.location.latitude + ',' + facility.location.longitude;
    }

    return query
  }

  static fromAsset(asset: Asset): FacilityCompat {
    const facility: FacilityCompat = { attributes: asset?.attributes, source: asset, };
    for (const a of asset.attributes) {
      switch (a.name) {
        case 'FacilityName':
          facility.name = a.value;
          break;
        case 'FacilityAddress1':
          facility.address1 = a.value;
          break;
        case 'FacilityAddress2':
          facility.address2 = a.value;
          break;
        case 'FacilityCity':
          facility.city = a.value;
          break;
        case 'FacilityState':
          facility.state = a.value;
          break;
        case 'FacilityPostalCode':
          facility.postalCode = a.value;
          break;
        case 'FacilityCountry':
          facility.country = a.value;
          break;
        case 'FacilityLocation':
          facility.location = this.parseGeoLocation(a.value);
          break;
        case 'Area':
          facility.areaAttr = a;
          break;
        case 'SubArea':
          facility.subAreaAttr = a;
          break;
        case 'LocationType':
          facility.typeAttr = a;
          break;
        case 'Brand':
          facility.brandAttr = a;
          break;
        case 'BrandGroups':
          facility.brandGroupsAttr = a;
          break;
      }
    }
    return facility;
  }
}